export default __webpack_public_path__ + "static/media/img_company_header32.c0a39395.png";